import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import type { NoTransferReason } from './ExperienceTransferUtils'

const ErrorPane = styled(Pane)`
  padding: ${rem(12)};
`

interface Props {
  reason: NoTransferReason
}

function ExperienceTransferBookingOptionError(props: Props) {
  const { reason } = props
  const intl = useIntl()

  const distanceBoldMessage = intl.formatMessage({
    id: 'GRAAW7inXRWNyzHILtJD',
    defaultMessage: 'Sorry, there are no vehicles available for your transfer request.',
    description: 'Error message when no vehicles are available due to distance',
  })
  const passengersBoldMessage = intl.formatMessage({
    id: 'OpYtd2qvntUyGmceUj6K',
    defaultMessage: 'Sorry, there are no vehicles available for the travellers selected.',
    description: 'Error message when no vehicles are available for the number of travellers',
  })
  const childSeatsBoldMessage = intl.formatMessage({
    id: '6087VIDIg9rnm5SdXg6P',
    defaultMessage: 'Sorry, there are no vehicles available for the child seats selected.',
    description: 'Error message when no vehicles are available for the number of child seats',
  })
  const bagsBoldMessage = intl.formatMessage({
    id: 'cRpL7o0eTuDqwMZPeh0V',
    defaultMessage: 'Sorry, there are no vehicles available for the number of bags selected.',
    description: 'Error message when no vehicles are available for the number of bags',
  })

  const distanceDetailMessage = intl.formatMessage({
    id: 'JKMM_Ovlc3ly2wPcO7Im',
    defaultMessage: 'Please update your transfer details and try again.',
    description: 'Detail message suggesting to update transfer details after distance error',
  })
  const passengersDetailMessage = intl.formatMessage({
    id: 'YRGP6LeB_c3gYuj4iZSN',
    defaultMessage: 'Please update the number of travellers and try again',
    description: 'Detail message suggesting to update number of travellers',
  })
  const childSeatsDetailMessage = intl.formatMessage({
    id: 'RRv1BfiQrPgTAKO4lgPy',
    defaultMessage: 'Please update the number of child seats and try again',
    description: 'Detail message suggesting to update number of child seats',
  })
  const bagsDetailMessage = intl.formatMessage({
    id: 'kCAy1yP1PGRQxIRkEczp',
    defaultMessage: 'Please update the number of bags and try again',
    description: 'Detail message suggesting to update number of bags',
  })

  return <ErrorPane background="light-background">
    <VerticalSpacer gap={4}>
      <BodyText variant="medium" weight="bold">
        {reason === 'distance' && distanceBoldMessage}
        {reason === 'passengers' && passengersBoldMessage}
        {reason === 'childSeats' && childSeatsBoldMessage}
        {reason === 'bags' && bagsBoldMessage}
      </BodyText>
      <BodyText variant="small" colour="light-foreground-alt">
        {reason === 'distance' && distanceDetailMessage}
        {reason === 'passengers' && passengersDetailMessage}
        {reason === 'childSeats' && childSeatsDetailMessage}
        {reason === 'bags' && bagsDetailMessage}
      </BodyText>
    </VerticalSpacer>
  </ErrorPane>
}

export default ExperienceTransferBookingOptionError
